"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSaasLiveroomId = setSaasLiveroomId;
exports.getSaasLiveroomId = getSaasLiveroomId;
exports.isInSaasLiveroom = isInSaasLiveroom;
exports.isSaasLiveroom = isSaasLiveroom;
exports.getSaaSLiveroomAuthState = getSaaSLiveroomAuthState;
exports.isSaasLiveRoomSubscribed = isSaasLiveRoomSubscribed;
exports.isAuthNeeded = isAuthNeeded;
exports.getOauthURL = getOauthURL;
exports.isSaasLiveroomV2 = isSaasLiveroomV2;

var _saas = require("../constants/saas");

var _http = require("../lib/http");

var _toolkit = require("@weike/toolkit");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * 保存机构版 直播间 id 到 sessionStorage
 *
 * @export
 * @param {number} liveroomId
 */
function setSaasLiveroomId(liveroomId) {
  window.sessionStorage.setItem(_saas.SAAS_LIVEROOM_ID, liveroomId.toString());
}
/**
 * 从 sessionStorage 获取访问过的机构版直播间 id
 *
 * @export
 * @returns
 */


function getSaasLiveroomId() {
  return window.sessionStorage.getItem(_saas.SAAS_LIVEROOM_ID);
}
/**
 * 判断是否为机构版页面(是否访问过机构版直播间)
 *
 * @export
 * @returns
 */


function isInSaasLiveroom() {
  return Boolean(getSaasLiveroomId());
}
/**
 * 判断直播间是否为机构版
 * 同时如果是独立直播间，而且在微信中，则会进行独立直播间公众号授权
 *
 * @export
 * @param {number} liveroomId 直播间 id
 * @param {string} [env='production'] 应用环境, 从 process.REACT_APP_RUNTIME 获取
 * @returns {Promise<boolean>}
 */


function isSaasLiveroom(_x) {
  return _isSaasLiveroom.apply(this, arguments);
}

function _isSaasLiveroom() {
  _isSaasLiveroom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(liveroomId) {
    var env,
        http,
        isSaasLiveroomRes,
        isNotAuthBefore,
        redirectURL,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            env = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'production';
            http = (0, _http.setupApiRequest)(env, 'v1');
            _context.prev = 2;
            _context.next = 5;
            return http.get('/wk_open_mp/wxapp.auth.check', {
              params: {
                outer_object_id: liveroomId,
                outer_object_type: 'liveroom',
                version: '1.0'
              }
            });

          case 5:
            isSaasLiveroomRes = _context.sent;

            if (!((0, _toolkit.isWechat)() && isSaasLiveroomRes.data.result)) {
              _context.next = 21;
              break;
            }

            _context.prev = 7;
            _context.next = 10;
            return isAuthNeeded(liveroomId, env);

          case 10:
            isNotAuthBefore = _context.sent;

            if (!isNotAuthBefore) {
              _context.next = 17;
              break;
            }

            _context.next = 14;
            return getOauthURL(liveroomId, env);

          case 14:
            redirectURL = _context.sent;
            window.location.replace(redirectURL);
            return _context.abrupt("return", Promise.reject());

          case 17:
            _context.next = 21;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](7);

          case 21:
            return _context.abrupt("return", isSaasLiveroomRes.data.result);

          case 24:
            _context.prev = 24;
            _context.t1 = _context["catch"](2);
            return _context.abrupt("return", false);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 24], [7, 19]]);
  }));
  return _isSaasLiveroom.apply(this, arguments);
}

// 待补充
function getSaaSLiveroomAuthState(_x2) {
  return _getSaaSLiveroomAuthState.apply(this, arguments);
}
/**
 * 判断用户是否关注过机构版直播间的微信公众号
 *
 * @export
 * @param {number} liveroomId 直播间 id
 * @param {string} [env='production'] 应用环境, 从 process.REACT_APP_RUNTIME 获取
 * @returns
 */


function _getSaaSLiveroomAuthState() {
  _getSaaSLiveroomAuthState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(liveroomId) {
    var env,
        http,
        isSubscribedRes,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            env = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'production';
            _context2.prev = 1;
            http = (0, _http.setupApiRequest)(env, 'v1');
            _context2.next = 5;
            return http.get('/wk_open_mp/wxapp.subscribe.get', {
              params: {
                version: '1.0',
                outer_object_id: liveroomId,
                outer_object_type: 'liveroom'
              }
            });

          case 5:
            isSubscribedRes = _context2.sent;
            return _context2.abrupt("return", isSubscribedRes.data.is_subscribed);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", 0);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));
  return _getSaaSLiveroomAuthState.apply(this, arguments);
}

function isSaasLiveRoomSubscribed(_x3) {
  return _isSaasLiveRoomSubscribed.apply(this, arguments);
}
/**
 * 判断用户是否需要跳转去授权机构版直播间的微信公众号
 *
 * @export
 * @param {number} liveroomId
 * @param {string} [env='production']
 * @returns
 */


function _isSaasLiveRoomSubscribed() {
  _isSaasLiveRoomSubscribed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(liveroomId) {
    var env,
        state,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            env = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 'production';
            _context3.next = 3;
            return getSaaSLiveroomAuthState(liveroomId, env);

          case 3:
            state = _context3.sent;
            return _context3.abrupt("return", state === 1);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _isSaasLiveRoomSubscribed.apply(this, arguments);
}

function isAuthNeeded(_x4) {
  return _isAuthNeeded.apply(this, arguments);
}
/**
 * 获取机构版微信公众号授权跳转地址
 *
 * @export
 * @param {number} liveroomId 直播间 id
 * @param {string} [env='production'] 应用环境, 从 process.REACT_APP_RUNTIME 获取
 * @param {*} [redirectURL=window.location.href] 授权完成以后的回调地址
 * @returns
 */


function _isAuthNeeded() {
  _isAuthNeeded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(liveroomId) {
    var env,
        state,
        _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            env = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 'production';
            _context4.next = 3;
            return getSaaSLiveroomAuthState(liveroomId, env);

          case 3:
            state = _context4.sent;
            return _context4.abrupt("return", state === -1);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _isAuthNeeded.apply(this, arguments);
}

function getOauthURL(_x5) {
  return _getOauthURL.apply(this, arguments);
}
/**
 * 判断直播间是否为机构版v2接口，增加参数
 * 同时如果是独立直播间，而且在微信中，则会进行独立直播间公众号授权
 *  
 * @export
 * @param {number} liveroomId 直播间 id
 * @param {string} [env='production'] 应用环境, 从 process.REACT_APP_RUNTIME 获取
 * @returns {Promise<{
 *  isSaaS: boolean 是不是独立课堂
 *  use_mp: boolean 是否使用公众号 - 即是不是有绑定公众号
 *  liveroom_type: string 直播间类型
 * }>}
 */


function _getOauthURL() {
  _getOauthURL = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(liveroomId) {
    var env,
        redirectURL,
        http,
        redirectRes,
        _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            env = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 'production';
            redirectURL = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : window.location.href;
            _context5.prev = 2;
            http = (0, _http.setupApiRequest)(env, 'v1');
            _context5.next = 6;
            return http.get('/wk_open_mp/wxapp.auth_redirect.get', {
              params: {
                outer_object_id: liveroomId,
                redirect_type: 'oauth2',
                redirect_url: encodeURIComponent(redirectURL),
                version: '1.0'
              }
            });

          case 6:
            redirectRes = _context5.sent;
            return _context5.abrupt("return", redirectRes.data.open_mp_redirect_url);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](2);
            return _context5.abrupt("return", '');

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 10]]);
  }));
  return _getOauthURL.apply(this, arguments);
}

function isSaasLiveroomV2(_x6) {
  return _isSaasLiveroomV.apply(this, arguments);
}

function _isSaasLiveroomV() {
  _isSaasLiveroomV = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(liveroomId) {
    var env,
        http,
        isSaasLiveroomRes,
        isNotAuthBefore,
        redirectURL,
        _args6 = arguments;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            env = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 'production';
            http = (0, _http.setupRequestGw)(env);
            _context6.prev = 2;
            _context6.next = 5;
            return http.get('/integration/cont_manager/v1/api/saas.info.get', {
              params: {
                liveroom_id: liveroomId
              }
            });

          case 5:
            isSaasLiveroomRes = _context6.sent;

            if (!((0, _toolkit.isWechat)() && isSaasLiveroomRes.data.result)) {
              _context6.next = 21;
              break;
            }

            _context6.prev = 7;
            _context6.next = 10;
            return isAuthNeeded(liveroomId, env);

          case 10:
            isNotAuthBefore = _context6.sent;

            if (!isNotAuthBefore) {
              _context6.next = 17;
              break;
            }

            _context6.next = 14;
            return getOauthURL(liveroomId, env);

          case 14:
            redirectURL = _context6.sent;
            window.location.replace(redirectURL);
            return _context6.abrupt("return", Promise.reject());

          case 17:
            _context6.next = 21;
            break;

          case 19:
            _context6.prev = 19;
            _context6.t0 = _context6["catch"](7);

          case 21:
            return _context6.abrupt("return", _objectSpread({
              isSaaS: isSaasLiveroomRes.data.result
            }, isSaasLiveroomRes.data));

          case 24:
            _context6.prev = 24;
            _context6.t1 = _context6["catch"](2);
            return _context6.abrupt("return", {
              isSaaS: false,
              use_mp: false
            });

          case 27:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 24], [7, 19]]);
  }));
  return _isSaasLiveroomV.apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// ./~/@weike/services/lib/services/saas.js
// module id = 631
// module chunks = 4